import React from 'react';
import { COLORS } from '../../styles/variables';

interface ArrowIconProps {
  disabled?: boolean;
  arrowType?: 'up' | 'down' | 'left' | 'right';
}

const ArrowIcon: React.FC<ArrowIconProps> = ({ disabled, arrowType }) => {
  const strokeColor = disabled ? COLORS.grey30 : COLORS.black;

  const arrowUp = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 15.5L12.5 10L7 15.5" stroke={strokeColor} />
    </svg>
  );

  const arrowDown = (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 10.7826L12.5 16.2826L18 10.7826" stroke="black" />
    </svg>
  );

  const arrowLeft = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.9849 17.439L9.49991 11.996L14.9799 6.56104" stroke="black" />
    </svg>
  );

  if (arrowType === 'up') return arrowUp;
  if (arrowType === 'down') return arrowDown;
  if (arrowType === 'left') return arrowLeft;
  return arrowUp;
};

export default ArrowIcon;
